import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DoughnutChartModule } from '@portal-core/ui/charts/components/doughnut-chart/doughnut-chart.module';
import { ProjectChecklistDoughnutChartComponent } from './project-checklist-doughnut-chart.component';

@NgModule({
  declarations: [
    ProjectChecklistDoughnutChartComponent
  ],
  imports: [
    CommonModule,
    DoughnutChartModule
  ],
  exports: [
    ProjectChecklistDoughnutChartComponent
  ]
})
export class ProjectChecklistDoughnutChartModule { }
